import React from 'react';

const ComingSoon = ({ title = "Coming Soon" }) => {
  return (
    <section className="coming-soon-page">
      <div className="container">
        <div className="coming-soon-content">
          <div className="coming-soon-icon">
            <i className="fas fa-clock"></i>
          </div>
          <h1 className="coming-soon-title">{title}</h1>
          <p className="coming-soon-description">
            We're working hard to bring you something amazing! This feature is currently under development and will be available soon.
          </p>
          <div className="coming-soon-features">
            <div className="feature-item">
              <i className="fas fa-check-circle"></i>
              <span>Enhanced user experience</span>
            </div>
            <div className="feature-item">
              <i className="fas fa-check-circle"></i>
              <span>Better functionality</span>
            </div>
            <div className="feature-item">
              <i className="fas fa-check-circle"></i>
              <span>Improved performance</span>
            </div>
          </div>
          <div className="coming-soon-actions">
            <a href="/home" className="btn btn-primary">Back to Home</a>
            <a href="/home#contact" className="btn btn-secondary">Contact Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComingSoon;
